/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddShortlistPlayerDto,
  CreateShortlistDto,
  RemoveShortlistResponseDto,
  ShortlistDto,
  ShortlistsControllerListShortlistsV1200,
  ShortlistsControllerListShortlistsV1Params,
  UpdateShortlistDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getShortlistsControllerListShortlistsV1Url = (params?: ShortlistsControllerListShortlistsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/shortlists?${stringifiedParams}` : `/v1/shortlists`
}

/**
 * @summary Shortlists you can see
 */
export const shortlistsControllerListShortlistsV1 = async (params?: ShortlistsControllerListShortlistsV1Params, options?: RequestInit): Promise<ShortlistsControllerListShortlistsV1200> => {

  return apiRequest<ShortlistsControllerListShortlistsV1200>(getShortlistsControllerListShortlistsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShortlistsControllerListShortlistsV1QueryKey = (params?: ShortlistsControllerListShortlistsV1Params,) => {
    return [
    `/v1/shortlists`, ...(params ? [params] : [])
    ] as const;
    }


export const getShortlistsControllerListShortlistsV1QueryOptions = <TData = Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError = unknown>(params?: ShortlistsControllerListShortlistsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShortlistsControllerListShortlistsV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>> = ({ signal }) => shortlistsControllerListShortlistsV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShortlistsControllerListShortlistsV1QueryResult = NonNullable<Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>>
export type ShortlistsControllerListShortlistsV1QueryError = unknown


export function useShortlistsControllerListShortlistsV1<TData = Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError = unknown>(
 params: undefined |  ShortlistsControllerListShortlistsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerListShortlistsV1<TData = Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError = unknown>(
 params?: ShortlistsControllerListShortlistsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerListShortlistsV1<TData = Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError = unknown>(
 params?: ShortlistsControllerListShortlistsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Shortlists you can see
 */

export function useShortlistsControllerListShortlistsV1<TData = Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError = unknown>(
 params?: ShortlistsControllerListShortlistsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerListShortlistsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShortlistsControllerListShortlistsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShortlistsControllerCreateShortlistV1Url = () => {




  return `/v1/shortlists`
}

/**
 * @summary Create a shortlist
 */
export const shortlistsControllerCreateShortlistV1 = async (createShortlistDto: CreateShortlistDto, options?: RequestInit): Promise<ShortlistDto> => {

  return apiRequest<ShortlistDto>(getShortlistsControllerCreateShortlistV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createShortlistDto)
  }
);}





export const getShortlistsControllerCreateShortlistV1QueryKey = (createShortlistDto?: CreateShortlistDto,) => {
    return [
    'POST', `/v1/shortlists`, createShortlistDto
    ] as const;
    }


export const getShortlistsControllerCreateShortlistV1QueryOptions = <TData = Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError = unknown>(createShortlistDto: CreateShortlistDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShortlistsControllerCreateShortlistV1QueryKey(createShortlistDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>> = ({ signal }) => shortlistsControllerCreateShortlistV1(createShortlistDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShortlistsControllerCreateShortlistV1QueryResult = NonNullable<Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>>
export type ShortlistsControllerCreateShortlistV1QueryError = unknown


export function useShortlistsControllerCreateShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError = unknown>(
 createShortlistDto: CreateShortlistDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerCreateShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError = unknown>(
 createShortlistDto: CreateShortlistDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerCreateShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError = unknown>(
 createShortlistDto: CreateShortlistDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create a shortlist
 */

export function useShortlistsControllerCreateShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError = unknown>(
 createShortlistDto: CreateShortlistDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerCreateShortlistV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShortlistsControllerCreateShortlistV1QueryOptions(createShortlistDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShortlistsControllerFindOneV1Url = (id: string,) => {




  return `/v1/shortlists/${id}`
}

/**
 * @summary One shortlist
 */
export const shortlistsControllerFindOneV1 = async (id: string, options?: RequestInit): Promise<ShortlistDto> => {

  return apiRequest<ShortlistDto>(getShortlistsControllerFindOneV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShortlistsControllerFindOneV1QueryKey = (id: string,) => {
    return [
    `/v1/shortlists/${id}`
    ] as const;
    }


export const getShortlistsControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShortlistsControllerFindOneV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>> = ({ signal }) => shortlistsControllerFindOneV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShortlistsControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>>
export type ShortlistsControllerFindOneV1QueryError = unknown


export function useShortlistsControllerFindOneV1<TData = Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerFindOneV1<TData = Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerFindOneV1<TData = Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One shortlist
 */

export function useShortlistsControllerFindOneV1<TData = Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShortlistsControllerFindOneV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShortlistsControllerUpdateShortlistV1Url = (id: string,) => {




  return `/v1/shortlists/${id}`
}

/**
 * Owner only — a 403 otherwise, even for a shared shortlist.
 * @summary Rename a shortlist, or change who can see it
 */
export const shortlistsControllerUpdateShortlistV1 = async (id: string,
    updateShortlistDto: UpdateShortlistDto, options?: RequestInit): Promise<ShortlistDto> => {

  return apiRequest<ShortlistDto>(getShortlistsControllerUpdateShortlistV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateShortlistDto)
  }
);}





export const getShortlistsControllerUpdateShortlistV1QueryKey = (id: string,
    updateShortlistDto?: UpdateShortlistDto,) => {
    return [
    'PATCH', `/v1/shortlists/${id}`, updateShortlistDto
    ] as const;
    }


export const getShortlistsControllerUpdateShortlistV1QueryOptions = <TData = Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError = unknown>(id: string,
    updateShortlistDto: UpdateShortlistDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShortlistsControllerUpdateShortlistV1QueryKey(id,updateShortlistDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>> = ({ signal }) => shortlistsControllerUpdateShortlistV1(id,updateShortlistDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShortlistsControllerUpdateShortlistV1QueryResult = NonNullable<Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>>
export type ShortlistsControllerUpdateShortlistV1QueryError = unknown


export function useShortlistsControllerUpdateShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError = unknown>(
 id: string,
    updateShortlistDto: UpdateShortlistDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerUpdateShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError = unknown>(
 id: string,
    updateShortlistDto: UpdateShortlistDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerUpdateShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError = unknown>(
 id: string,
    updateShortlistDto: UpdateShortlistDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Rename a shortlist, or change who can see it
 */

export function useShortlistsControllerUpdateShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError = unknown>(
 id: string,
    updateShortlistDto: UpdateShortlistDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerUpdateShortlistV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShortlistsControllerUpdateShortlistV1QueryOptions(id,updateShortlistDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShortlistsControllerRemoveShortlistV1Url = (id: string,) => {




  return `/v1/shortlists/${id}`
}

/**
 * Owner only. The players themselves are untouched.
 * @summary Delete a shortlist
 */
export const shortlistsControllerRemoveShortlistV1 = async (id: string, options?: RequestInit): Promise<RemoveShortlistResponseDto> => {

  return apiRequest<RemoveShortlistResponseDto>(getShortlistsControllerRemoveShortlistV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getShortlistsControllerRemoveShortlistV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/shortlists/${id}`
    ] as const;
    }


export const getShortlistsControllerRemoveShortlistV1QueryOptions = <TData = Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShortlistsControllerRemoveShortlistV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>> = ({ signal }) => shortlistsControllerRemoveShortlistV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShortlistsControllerRemoveShortlistV1QueryResult = NonNullable<Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>>
export type ShortlistsControllerRemoveShortlistV1QueryError = unknown


export function useShortlistsControllerRemoveShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerRemoveShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerRemoveShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a shortlist
 */

export function useShortlistsControllerRemoveShortlistV1<TData = Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemoveShortlistV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShortlistsControllerRemoveShortlistV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShortlistsControllerAddPlayerV1Url = (id: string,) => {




  return `/v1/shortlists/${id}/players`
}

/**
 * Idempotent: adding someone already on the list updates their note and rank rather than erroring.
 * @summary Put a player on the shortlist
 */
export const shortlistsControllerAddPlayerV1 = async (id: string,
    addShortlistPlayerDto: AddShortlistPlayerDto, options?: RequestInit): Promise<ShortlistDto> => {

  return apiRequest<ShortlistDto>(getShortlistsControllerAddPlayerV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addShortlistPlayerDto)
  }
);}





export const getShortlistsControllerAddPlayerV1QueryKey = (id: string,
    addShortlistPlayerDto?: AddShortlistPlayerDto,) => {
    return [
    'POST', `/v1/shortlists/${id}/players`, addShortlistPlayerDto
    ] as const;
    }


export const getShortlistsControllerAddPlayerV1QueryOptions = <TData = Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError = unknown>(id: string,
    addShortlistPlayerDto: AddShortlistPlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShortlistsControllerAddPlayerV1QueryKey(id,addShortlistPlayerDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>> = ({ signal }) => shortlistsControllerAddPlayerV1(id,addShortlistPlayerDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShortlistsControllerAddPlayerV1QueryResult = NonNullable<Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>>
export type ShortlistsControllerAddPlayerV1QueryError = unknown


export function useShortlistsControllerAddPlayerV1<TData = Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError = unknown>(
 id: string,
    addShortlistPlayerDto: AddShortlistPlayerDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerAddPlayerV1<TData = Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError = unknown>(
 id: string,
    addShortlistPlayerDto: AddShortlistPlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerAddPlayerV1<TData = Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError = unknown>(
 id: string,
    addShortlistPlayerDto: AddShortlistPlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Put a player on the shortlist
 */

export function useShortlistsControllerAddPlayerV1<TData = Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError = unknown>(
 id: string,
    addShortlistPlayerDto: AddShortlistPlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerAddPlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShortlistsControllerAddPlayerV1QueryOptions(id,addShortlistPlayerDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getShortlistsControllerRemovePlayerV1Url = (id: string,
    playerId: string,) => {




  return `/v1/shortlists/${id}/players/${playerId}`
}

/**
 * @summary Take a player off the shortlist
 */
export const shortlistsControllerRemovePlayerV1 = async (id: string,
    playerId: string, options?: RequestInit): Promise<ShortlistDto> => {

  return apiRequest<ShortlistDto>(getShortlistsControllerRemovePlayerV1Url(id,playerId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getShortlistsControllerRemovePlayerV1QueryKey = (id: string,
    playerId: string,) => {
    return [
    'DELETE', `/v1/shortlists/${id}/players/${playerId}`
    ] as const;
    }


export const getShortlistsControllerRemovePlayerV1QueryOptions = <TData = Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError = unknown>(id: string,
    playerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShortlistsControllerRemovePlayerV1QueryKey(id,playerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>> = ({ signal }) => shortlistsControllerRemovePlayerV1(id,playerId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && playerId !== null && playerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShortlistsControllerRemovePlayerV1QueryResult = NonNullable<Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>>
export type ShortlistsControllerRemovePlayerV1QueryError = unknown


export function useShortlistsControllerRemovePlayerV1<TData = Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError = unknown>(
 id: string,
    playerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerRemovePlayerV1<TData = Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError = unknown>(
 id: string,
    playerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>,
          TError,
          Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShortlistsControllerRemovePlayerV1<TData = Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError = unknown>(
 id: string,
    playerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Take a player off the shortlist
 */

export function useShortlistsControllerRemovePlayerV1<TData = Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError = unknown>(
 id: string,
    playerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shortlistsControllerRemovePlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShortlistsControllerRemovePlayerV1QueryOptions(id,playerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






